import { render, staticRenderFns } from "./SettingsDashboard.vue?vue&type=template&id=29b5838b&scoped=true&lang=pug"
import script from "./SettingsDashboard.vue?vue&type=script&lang=js"
export * from "./SettingsDashboard.vue?vue&type=script&lang=js"
import style0 from "./SettingsDashboard.vue?vue&type=style&index=0&id=29b5838b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b5838b",
  null
  
)

export default component.exports